import React, { useState, useContext } from 'react';
import YesNo from '../../../../../../components/Dialog/YesNo';
import TextField from '@material-ui/core/TextField';
import normalizeMobile from '../../../../../../fns/normalizeMobile';
import axios from '../../../../../../api/axios';
import { store } from '../../../../../../store';
import { CircularProgress } from '@material-ui/core';

const SendSMSDialog = ({ order, driver, onClose }) => {
  const initialMobileNumber = order.cargos[0].destination?.mobilePhone;
  const [mobilePhone, setMobilePhone] = useState(
    initialMobileNumber ? initialMobileNumber : ''
  );
  const { showMessage, showError } = useContext(store);
  const [loading, setLoading] = useState(false);

  const handleClose = async (agree) => {
    if (!agree) {
      return onClose();
    }
    try {
      setLoading(true);
      const { data } = await axios.post(
        `/api/v1/admin/orders/sendDriverInformations`,
        {
          orderId: order._id,
          driverId: driver._id,
          mobilePhone,
        }
      );
      showMessage(data.messages);
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
      onClose();
    }
  };
  const handleChange = (e) => {
    let { value } = e.target;
    setMobilePhone(value);
  };
  return (
    <YesNo
      title="ارسال مشخصات راننده"
      yes="ارسال"
      no="صرفنظر"
      open={!!driver}
      onClose={handleClose}
      fullWidth={false}
      loadingButton
      endIcon={loading ? <CircularProgress size={10} /> : <></>}
      inProgress={loading}
    >
      <TextField
        fullWidth
        label="موبایل گیرنده بار"
        variant="outlined"
        size="medium"
        value={normalizeMobile(mobilePhone)}
        onChange={handleChange}
      />
    </YesNo>
  );
};

export default React.memo(SendSMSDialog);
